module.exports = __webpack_public_path__ + "static/media/Money Bag.3d0565f2.svg";